module.exports = __webpack_public_path__ + "img/yzh1.0548efff.jpg";